<!-- <p>
    Va multumim pentru plata de {{transaction.amount}}
    <ng-container *ngIf="transaction.transactionSystem == 'Mobilpay - sms'">EUR</ng-container>
    <ng-container *ngIf="transaction.transactionSystem != 'Mobilpay - sms'">RON</ng-container>
    !
</p> -->


<ng-container>
    <div nz-row>
        <div
            nz-col
            nzSpan="16"
            [ngClass]="'p-3'"
        >

            <div class="check-icon-wrapper">
                <svg version="1.1" id="check-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                 viewBox="0 0 405.272 405.272"
                xml:space="preserve">
                    <g>
                        <path d="M393.401,124.425L179.603,338.208c-15.832,15.835-41.514,15.835-57.361,0L11.878,227.836
                            c-15.838-15.835-15.838-41.52,0-57.358c15.841-15.841,41.521-15.841,57.355-0.006l81.698,81.699L336.037,67.064
                            c15.841-15.841,41.523-15.829,57.358,0C409.23,82.902,409.23,108.578,393.401,124.425z"/>
                    </g>
                </svg>
            </div>

            <h1
                nz-typography
                style="text-align: center;"
            >
                V&#259; mul&#355;umim pentru &#238;ncredere<br/> &#351;i pentru plata de <span class="amount">{{transaction.amount}}</span>
                <ng-container *ngIf="transaction.transactionSystem == 'Mobilpay - sms'"> EUR</ng-container>
                <ng-container *ngIf="transaction.transactionSystem != 'Mobilpay - sms'"> RON</ng-container>
                efectuat&#259;.
            </h1>

            <h2
                style="text-align: center;"
            >
                S&#259; fie cash &#351;i s&#259; ave&#355;i mult&#259; energie!
            </h2>

            <p
                style="text-align: center;"
            >În scurt timp veţi fi redirecţionat către pagina de încărcare balanţă.</p>
        </div>
    </div>
</ng-container>

